import styled from 'styled-components';

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 1.5rem 1.5rem 1.5rem;
  background-color: ${({ theme }) => theme.colors.white};

  .inputContainer {
    display: flex;
    gap: 1.5rem;
    align-items: flex-end;

    .button-container {
      min-width: 10.75rem;
      min-height: 3rem;
      align-self: flex-end;
    }
  }
`;
